<script>
import 'bulma/css/bulma.css'
import QuestionCard from '@/components/QuestionCard'
import imageCompression from 'browser-image-compression'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserId, getMyUserData, updateMyUserData, resetStoreUserData } from '@/api/FirebaseUserWrapper.js'
import { putProfileImageInStorage } from '@/api/FirebaseStorageWrapper.js'
import { hasAdminRole } from '@/api/Utilities.js'

const analytics = getAnalytics(firebaseApp)
require('@/css/style.css')

export default {
  components: {
    QuestionCard,
    imageCompression
  },
  data () {
    return {
      userId: '',
      myData: {},
      myImageUrl: '',
      saveDoneFlag: false,
      saveDoneMsg: '',
      isAnonymous: true, // 一瞬見えるのを防止するため
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    this.userId = await getMyUserId()
    this.myData = await getMyUserData(this.userId)
    this.isAnonymous = this.myData.isAnonymous
    this.myImageUrl = this.myData.imageUrl
    document.title = 'EditProfile | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'EditProfile | ' + this.title)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'editprofile/EditProfile')
    }
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  methods: {
    async saveProfile () {
      if (location.hostname !== 'qnqtree.com') { console.log(`EditProfile: saveProfile()`) }
      if (!this.myData.name) {
        this.saveDoneMsg = 'failed!'
        this.saveDoneFlag = true
        return
      }
      try {
        const updatedMyData = {
          clipBoardFlag: this.myData.clipBoardFlag,
          email: this.myData.email,
          emailFlag: this.myData.emailFlag,
          imageUrl: this.myImageUrl,
          introduction: this.myData.introduction,
          name: this.myData.name,
          navigation: this.myData.navigation,
          nodeDirection: this.myData.nodeDirection,
          soundFlag: this.myData.soundFlag,
          twitterName: this.myData.twitterName,
          url: this.myData.url
        }
        await updateMyUserData(updatedMyData)
        this.saveDoneMsg = 'success!'
        // Storeをリセットして更新
        await resetStoreUserData()
      } catch (err) {
        console.error(err)
        this.saveDoneMsg = 'failed!'
      }
      this.saveDoneFlag = true
      setTimeout(() => { this.saveDoneFlag = false }, 3000)
    },
    async uploadFile (file) {
      const url = await putProfileImageInStorage(file)
      if (!url) { return }
      const updatedMyData = {
        imageUrl: url
      }
      await updateMyUserData(updatedMyData)
      this.myImageUrl = url
      await resetStoreUserData()
    },
    selectedFile: async function (e) {
      // 選択された File の情報を保存しておく
      const files = e.target.files
      if (!files) { return }
      // console.log('生データ')
      // console.log(files[0])
      // console.log(files[0].size / 1024 / 1024 + 'MB')
      const compressFile = await this.getCompressFile(files[0])
      // console.log('圧縮データ')
      // console.log(compressFile)
      // console.log(compressFile.size / 1024 / 1024 + 'MB')
      await this.uploadFile(compressFile)
    },
    async getCompressFile (file) {
      const options = {
        maxSizeMB: 0.1, // 最大ファイルサイズ
        maxWidthOrHeight: 256 // 最大画像幅もしくは高さ
      }
      try {
        // 圧縮画像の生成
        return await imageCompression(file, options)
      } catch (error) {
        console.error('getCompressImageFileAsync is error', error)
        throw error
      }
    },
    toggleSoundBtn () {
      // リアクティブな書き方
      this.$set(this.myData, 'soundFlag', !this.myData.soundFlag)
    },
    toggleEmailBtn () {
      // リアクティブな書き方
      this.$set(this.myData, 'emailFlag', !this.myData.emailFlag)
    },
    toggleClipBtn () {
      // リアクティブな書き方
      this.$set(this.myData, 'clipBoardFlag', !this.myData.clipBoardFlag)
    }
  }
}

</script>
<style scoped>
.setting {
  max-width: 768px;
  margin: auto;
  padding: 1.0rem;
}
.file-centered {
  justify-content: center;
}
</style>
<template>
<div class='setting' v-if="!isAnonymous">
  <article class="media">
    <figure class="media-left">
      <label class="file-label file-centered">
        <input class="file-input" type="file" name="resume" @change="selectedFile" accept="image/png, image/jpeg">
        <p class="image is-96x96">
          <img class="is-rounded" :src="myImageUrl">
        </p>
      </label>
      <br>
      <div class="file is-dark is-small">
        <label class="file-label">
          <input class="file-input" type="file" name="resume" @change="selectedFile">
          <span class="file-cta">
            <span class="file-icon">
              <i class="fa-solid fa-upload"></i>
            </span>
            <span class="file-label">
              画像のアップロード
            </span>
          </span>
        </label>
      </div>
    </figure>
    <div class="media-content">
      <div class="content">
          <div class="buttons has-addons is-right is-marginless">
            <button class="button is-link is-focused has-text-weight-bold" @click="saveProfile">
              <span class="icon">
                <i class="fa-solid fa-paperclip"></i>
              </span>
              <span>SAVE</span>
            </button>
          </div>
          <div class="has-text-right" v-if="saveDoneFlag">
            {{ this.saveDoneMsg }}
          </div>
      </div>
    </div>
  </article>
  <br>
  <label class="label has-text-left">公開情報</label>
  <div class="field">
    <label class="label has-text-left is-size-7">NAME</label>
    <div class="control has-icons-left has-icons-right is-size-7">
      <input class="input is-size-7" type="text" placeholder="Text input" v-model="myData.name">
      <span class="icon is-small is-left">
        <i class="fa-solid fa-user"></i>
      </span>
    </div>
  </div>
  <div class="field">
    <label class="label has-text-left is-size-7">Web URL</label>
    <div class="control has-icons-left has-icons-right is-size-7">
      <input class="input is-size-7" type="textarea" placeholder="https://" v-model="myData.url">
      <span class="icon is-small is-left">
        <i class="fa-solid fa-link"></i>
      </span>
    </div>
  </div>
  <div class="field has-text-left">
    <label class="label has-text-left is-size-7">Twitter Account</label>
    <div class="control has-icons-left has-icons-right is-size-7">
      <input class="input is-size-7" type="textarea" placeholder="account" v-model="myData.twitterName">
      <span class="icon is-small is-left">
        <i class="fa-solid fa-link"></i>
      </span>
    </div>
  </div>
  <div class="field">
    <label class="label has-text-left is-size-7">INTRO</label>
    <div class="control ">
      <textarea class="textarea is-size-7" placeholder="Textarea" rows="2" v-model="myData.introduction"></textarea>
    </div>
  </div>
  <hr>
  <label class="label has-text-left">非公開情報</label>
  <div class="field">
    <label class="label has-text-left is-size-7">操作方法</label>
    <div class="columns is-multiline is-mobile is-marginless">
      <div class="column is-paddingless is-half">
        <div class="control is-size-7 has-text-left">
          Tree画面でクリップボードを表示：
        </div>
      </div>
      <div class="column is-paddingless">
        <div class="control is-size-7 has-text-right">
          <span class="icon has-text-success" v-if="myData.clipBoardFlag" @click="toggleClipBtn()">
            <i class="fa-solid fa-lg fa-toggle-on"></i>
          </span>
          <span class="icon" v-else @click="toggleClipBtn()">
            <i class="fa-solid fa-lg fa-toggle-off"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-mobile is-marginless">
      <div class="column is-paddingless is-half">
        <p class="text is-size-7 has-text-left">予測カードを出す方向：</p>
      </div>
      <div class="column is-paddingless">
        <div class="control is-size-7 has-text-right">
          <label class="radio">
            <input type="radio" name="depth" value="depth" v-model="myData.nodeDirection">
            深さ方向
          </label>
          <label class="radio">
            <input type="radio" name="width" value="width" v-model="myData.nodeDirection">
            幅方向
          </label>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-mobile is-marginless">
      <div class="column is-paddingless is-half">
        <p class="text is-size-7 has-text-left">Treeを操作する：</p>
      </div>
      <div class="column is-paddingless">
        <div class="control is-size-7 has-text-right">
          <label class="radio">
            <input type="radio" name="trackpad" value="trackpad" v-model="myData.navigation">
            トラックパッド
          </label>
          <label class="radio">
            <input type="radio" name="mouse" value="mouse" v-model="myData.navigation">
            マウス
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="field">
    <label class="label has-text-left is-size-7">通知設定</label>
    <div class="columns is-multiline is-mobile is-marginless">
      <div class="column is-paddingless is-half">
        <div class="control is-size-7 has-text-left">
          通知音を出す：
        </div>
      </div>
      <div class="column is-paddingless">
        <div class="control is-size-7 has-text-right">
          <span class="icon has-text-success" v-if="myData.soundFlag" @click="toggleSoundBtn()">
            <i class="fa-solid fa-lg fa-toggle-on"></i>
          </span>
          <span class="icon" v-else @click="toggleSoundBtn()">
            <i class="fa-solid fa-lg fa-toggle-off"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-mobile is-marginless">
      <div class="column is-paddingless is-half">
        <div class="control is-size-7 has-text-left">
          メール通知を受け取る：
        </div>
      </div>
      <div class="column is-paddingless">
        <div class="control is-size-7 has-text-right">
          <span class="icon has-text-success" v-if="myData.emailFlag" @click="toggleEmailBtn()">
            <i class="fa-solid fa-lg fa-toggle-on"></i>
          </span>
          <span class="icon" v-else @click="toggleEmailBtn()">
            <i class="fa-solid fa-lg fa-toggle-off"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="field">
    <label class="label has-text-left is-size-7">Email</label>
    <div class="control has-icons-left has-icons-right is-size-7">
      <input class="input is-size-7" type="textarea" placeholder="Disabled input" v-model="myData.email" disabled>
      <span class="icon is-small is-left">
        <i class="fa-solid fa-envelope"></i>
      </span>
    </div>
  </div>
  <br>
  <!--
    <pre>{{$data}}</pre>
  -->
</div>
</template>



// WEBPACK FOOTER //
// src/pages/editprofile/EditProfile.vue